import { Directive } from '@angular/core';

@Directive({
    selector: '[app-table-cell]',
    host: { class: 'data-table-cell' },
    standalone: false
})
export class TableCellDirective {}
